
<template>
  <div>
    <el-table :data="list" border size="small">
      <el-table-column
        align="left"
        :label="category == 5 ? '使用日期' : '维修日期'"
        prop="used_date"
        v-if="category == 5 || category == 6"
      >
        <template slot-scope="scope">
          {{
            scope.row.used_date
              ? $time(scope.row.used_date).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column label="区块信息" v-if="category == 5">
        <template slot-scope="scope">
          <div v-for="param in scope.row.used_extra" :key="param.key">
            {{ param.label }}：{{ param.value }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="工作时长"
        prop="used_hour"
        v-if="category == 5"
      >
      </el-table-column>
      <el-table-column align="center" label="成品编号" v-if="category == 6">
        <template slot-scope="scope">
          <ProductLink
            :product="scope.row.product"
            v-if="scope.row.product_id"
          ></ProductLink>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="使用次数"
        prop="usage"
        v-if="category == 6"
      >
        <template slot-scope="scope">
          {{ scope.row.usage ? `第${scope.row.usage}次` : '-' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="维修更换情况"
        prop="inspection"
        v-if="category == 6"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="处理措施和结果"
        prop="solution"
        v-if="category == 6"
      >
      </el-table-column>
      <el-table-column align="center" label="操作人" prop="user_name">
      </el-table-column>
      <el-table-column align="center" label="操作时间" prop="created_at_human">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作类型" prop="category_name">
      </el-table-column>
      <el-table-column align="left" label="操作内容">
        <template slot-scope="scope">
          <div v-if="scope.row.used_date && category == 0">
            {{ scope.row.category == 6 ? '维修日期' : '使用日期' }}：{{
              $time(scope.row.used_date).format('YYYY-MM-DD')
            }}
          </div>
          <div v-if="[4, 5].includes(scope.row.category) && category == 0">
            工作时长：{{ scope.row.used_hour }}
          </div>
          <div
            v-if="
              scope.row.used_extra &&
              scope.row.used_extra.length > 0 &&
              category == 0
            "
          >
            <template v-if="scope.row.category == 7">
              <div class="font-12">附件</div>
              <div v-for="(param, index) in scope.row.used_extra" :key="index">
                <el-link
                  @click="handleDownload(param)"
                  type="primary"
                  class="font-12"
                  >{{ param.name }}</el-link
                >
              </div>
            </template>
            <template v-else>
              <div v-for="param in scope.row.used_extra" :key="param.key">
                {{ param.label }}：{{ param.value }}
              </div>
            </template>
          </div>
          <div v-html="scope.row.remark"></div>
          <div class="medio-container">
            <el-image
              v-for="url in scope.row.imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row.imgs"
            >
            </el-image>
            <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        label="操作"
        v-if="category == 5"
        v-permission="
          item.category == 1
            ? Auth.itemUseRecordDelete
            : Auth.instrumentItemUseRecordDelete
        "
      >
        <template slot-scope="scope">
          <el-popconfirm
            title="确认删除该使用记录吗？"
            @confirm="hanldeDelte(scope.$index, scope.row)"
            v-if="scope.row.category == 5 && scope.row.id > 0"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="category == 6">
        <template slot-scope="scope">
          <el-popconfirm
            title="确认删除该维修记录吗？"
            @confirm="hanldeDelte(scope.$index, scope.row)"
            v-permission="
              item.category == 1
                ? Auth.itemRepairRecordDelete
                : Auth.instrumentItemRepairRecordDelete
            "
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            type="primary"
            plain
            size="mini"
            v-if="scope.row.user_id == $store.state.userInfo.id"
            @click="hanldeEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <RepairFormer
      :model="record"
      :show.sync="recordFormerVisible"
      @updated="recordUpdated"
    ></RepairFormer>
  </div>
</template>

<script>
import { itemRecordList, itemRecordDelete } from '@/service/getData'
import RepairFormer from './repair_former'

export default {
  components: {
    RepairFormer,
  },
  props: {
    item: Object,
    category: {
      type: Number,
      default: 0,
    },
    hideAddBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      recordFormerVisible: false,
      record: {
        item_id: this.item.id,
        category: this.category,
        used_date: '',
        imgs: [],
        remark: '',
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await itemRecordList({
        item_id: this.item.id,
        category: this.category,
        page: 0,
        size: 100,
      })
      this.list = res.data.list
    },

    hanldeEdit(index, item) {
      this.record = { ...item }
      this.recordFormerVisible = true
    },

    recordUpdated(item) {
      let index = this.list.findIndex((v) => v.id === item.id)
      this.$set(this.list, index, item)
    },

    async hanldeDelte(index, row) {
      let res = await itemRecordDelete(row.id)
      if (res.code === 0) {
        this.list.splice(index, 1)
      }
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          switch (j) {
            default:
              return v[j]
          }
        }),
      )
    },
    formartList(list) {
      let data = []
      let merges = []

      let rowIndex = 0
      list.map((item) => {
        item.code = this.item.code
        item.model_number = this.item.model_number
        item.product_code = item.product.code
        if (item.usage) {
          item.usage = `第${item.usage}次`
        }
        item.used_date = this.$time(item.used_date).format('YYYY-MM-DD')
        item.remark = item.remark.replace(/<[^<>]+>/g, '')

        if (this.category == 5) {
          item.used_extra.map((p) => {
            item[p.key] = p.value
          })
        }

        rowIndex++
        data.push(item)
      })
      return { list: data, merges: merges }
    },
    handleDownload(file) {
      const x = new window.XMLHttpRequest()
      x.open('GET', file.url, true)
      x.responseType = 'blob'
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = file.name
        a.click()
      }
      x.send()
    },
    handleExport() {
      this.downloading = true
      import('@/vendor/Export2Excel').then((excel) => {
        let tHeader = [
          '配件编号',
          '型号',
          '使用日期',
          '使用区块',
          '井队号',
          '井号',
          '工作时长',
          '备注',
        ]

        let filterVal = [
          'code',
          'model_number',
          'used_date',
          'block',
          'well_team_number',
          'well_number',
          'used_hour',
          'remark',
        ]

        if (this.category == 6) {
          tHeader = [
            '配件编号',
            '型号',
            '维修日期',
            '成品编号',
            '使用次数',
            '拆检情况',
            '处理措施和结果',
            '备注',
          ]
          filterVal = [
            'code',
            'model_number',
            'used_date',
            'product_code',
            'usage',
            'inspection',
            'solution',
            'remark',
          ]
        }

        const d = this.formartList(this.list)
        const data = this.formatJson(filterVal, d.list)

        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            this.item.name + `${this.category == 5 ? '使用' : '维修'}记录表`,
        })
        this.downloading = false
        this.$emit('exported', true)
      })
    },
  },
}
</script>

<style scoped>
.export-btn {
  float: right;
}
</style>